goog.require('el8.template.multiuser_access.expiredCode');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.expiredCode = (function() {

    var that = {};
    var faxNumber = null;
    var faxCode = null;

    function sendNewCode(faxCode) {


        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('resendFax', [faxCode]),
            data: JSON.stringify({}),
            async: true,
            success: function(data) {
                $('#send-new-code').hide();
                $('.expired-code-refaxed').hide();
                $('#try-again').show();

                if (!data.error) {

                    $('.request-success').show();
                } else {

                    $('.request-failed').show();
                }
            }
        });
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }

        faxNumber = spec.faxNumber;
        faxCode = spec.faxCode;

        $('.main-content').html(
            el8.template.multiuser_access.expiredCode.content({
                faxNumber: faxNumber
            })
        );

        $('.request-success').hide();
        $('.request-failed').hide();
        $('#try-again').hide();

        $(document).on('click', '#send-new-code', function(event) {
            sendNewCode(faxCode);
        });

        $(document).on('click', '#try-again', function(event) {
            location.href="/efax/";
        });

    };

    return that;

})();